import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatPaginatorModule} from '@angular/material/paginator'
import { MatSortModule} from '@angular/material/sort'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatTableModule } from '@angular/material/table'
import { MatInputModule} from '@angular/material/input'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatIconModule } from '@angular/material/icon'
import { MatStepperModule } from '@angular/material/stepper'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MainComponent } from '@app/certificates/main/component/main.component';
import { SharedModule } from '@app/shared/modules/shared.module';
import { ActivationComponent } from './activation.component';
import { BissCheckComponent } from './biss-check/biss-check.component';
import { OtpValidationComponent } from './otp-validation/otp-validation.component';
import { DocumentsComponent } from './documents/documents.component';
import { PinPukComponent } from './pin-puk/pin-puk.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BissManager } from './services/biss-manager';
import { HttpClient } from '@angular/common/http';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { ActivationService } from './services/activation.service';
//import { DeviceDetectorModule } from 'ngx-device-detector/';


@NgModule({
  imports: [
    MatStepperModule,
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatIconModule,
    StoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    //DeviceDetectorModule.forRoot()
  
  ],

  exports: [
    SharedModule,
    StoreModule,
    EffectsModule,
    FormsModule
  ],
  declarations: [
    // MainComponent,
    ActivationComponent,
    BissCheckComponent,
    OtpValidationComponent,
    PinPukComponent,
    DocumentsComponent
    // ManagePageComponent,
    // ManageGridComponent,
    // DevicesPageComponent,
    // DevicesGridComponent,
    // PacksComponent,
    // ConsentsComponent,
    // PackItemsComponent,
    // HistoryComponent,
    // SigningHistoryComponent,
    // PackOrderComponent,
    // OrderComponent,
    // RequestedHistoryComponent,
    // PackPaymentComponent,
    // InvoiceFormComponent,
    // LocalizedCurrencyPipe,
    // LegalTypePipe,
    // EnumToArrayPipe,
    // CertificateDetailsComponent,
    // RevokeConsentComponent,
    // DecodeHtmlStringPipe,
    // RequestedHistoryDetailsComponent
  ],
  entryComponents: [ActivationComponent],
  providers: [
    BissManager,
    HttpClient,
    HeadersSetterHelper,
    ActivationService
  ]
})
export class ActivationModule { }
